import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

class DependencyQuiz extends HTMLElement {
  constructor() {
    super();

    this.currentStep = 0;
    this.steps = [...this.querySelectorAll("[data-step]")];
    this.resultEl = this.querySelector(".results");
    this.startBtn = this.querySelector("button");

    this.bundleSlider = document.querySelector("bundle-selector");

    gsap.registerPlugin(ScrollToPlugin);

    this.startBtn.addEventListener("click", this.changeStep.bind(this, 1));

    const initialHeight = this.startBtn.offsetHeight;

    gsap.set(this, { height: initialHeight });

    this.initialize();
  }

  initialize() {
    gsap.set(this.steps, { autoAlpha: 0 });
    gsap.set(this.resultEl, { autoAlpha: 0 });
    this.score = 0;
  }

  changeStep(step, e) {
    this.currentStep = step;

    if (step == 0) {
      this.initialize();
      gsap.set(this.startBtn, { autoAlpha: 1 });
    } else {
      const currentSection = this.steps[this.currentStep - 1];
      const sectionBtns = currentSection.querySelectorAll("button");

      if (!currentSection.bound) {
        sectionBtns.forEach((btn) => {
          btn.addEventListener("click", (e) =>
            this.changeStep(this.currentStep + 1, e)
          );
        });
      }
      currentSection.bound = true;

      if (step == 1) {
        gsap.to(this.startBtn, { autoAlpha: 0 });
        gsap.to(window, { scrollTo: { y: this, offsetY: 100 }, duration: 0.2 });
      }
      if (this.currentStep > 1) {
        const value = parseInt(e.target.value);
        this.score += value;
      }
      gsap.set(this.steps, { autoAlpha: 0 });
      if (this.currentStep < this.steps.length) {
        gsap.set(currentSection, { autoAlpha: 1 });
        console.log({ sectionBtns });
        gsap.fromTo(
          sectionBtns,
          { autoAlpha: 0, y: -10 },
          { autoAlpha: 1, y: 0, stagger: 0.15, ease: "back.inOut" }
        );
      } else {
        this.showResult();
      }
      gsap.to(this, { height: currentSection.offsetHeight, duration: 0.3 });
    }
  }

  showResult() {
    console.log(this.score);
    let dependenceLevel;
    let bundle;
    if (this.score < 3) {
      dependenceLevel = "low";
      bundle = {
        index: 1,
        name: "Low & Slow Bundle",
        duration: "6 days",
        url: "/products/new-low-slow"
      };
    } else if (this.score === 3 || this.score === 4) {
      dependenceLevel = "low to moderate";
      bundle = {
        index: 2,
        name: "Habit Kicker Bundle",
        duration: "12 days",
        url: "/products/new-habit-kicker"
      };
    } else if (this.score == 5 || this.score == 6) {
      dependenceLevel = "moderate";
      bundle = {
        index: 3,
        name: "Habit Kicker Bundle",
        duration: "18 days",
        url: "/products/new-habit-kicker"
      };
    } else if (this.score > 6) {
      dependenceLevel = "high";
      bundle = {
        index: 4,
        name: "Heavy Hitter Bundle",
        duration: "48 days",
        url: "/products/new-heavy-hitter"
      };
    }

    const h2 = document.createElement("h2");
    const p = document.createElement("p");
    h2.innerHTML = `Looks like you're a ${dependenceLevel} dependence nicotine user`;
    h2.className = "h2";
    p.className = "body";
    this.resultEl.prepend(h2, p);
    gsap.to(this.resultEl, { autoAlpha: 1 });

    this.resultEl
      .querySelector("button")
      .addEventListener("click", this.viewBundle.bind(this, bundle));
  }

viewBundle(bundle) {
  if (bundle.url) {
    window.location.href = bundle.url; // ← redirect to the matching product
  } else {
    console.error("No URL defined for bundle", bundle);
  }

  // reset the quiz visuals (optional)
  this.changeStep(0);
  gsap.to(this.resultEl, { autoAlpha: 0 });
  this.resultEl.querySelector("h2").remove();
  this.resultEl.querySelector("p").remove();
}
}

customElements.define("dependency-quiz", DependencyQuiz);
